function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Briefcase Icon");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "briefcase-Icon/Global/Business_Lines/@Work",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round"
}, /*#__PURE__*/React.createElement("g", {
  id: "briefcase-Group-11",
  transform: "translate(1.000000, 6.000000)",
  stroke: "currentcolor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M8.39056938,26.4561404 C4.09701185,26.4561404 0.61640588,22.9617607 0.61640588,18.6512124 L0.61640588,6.38596491 L51.7041252,6.38596491 L51.7041252,18.6512124 C51.7041252,22.9617607 48.2226811,26.4561404 43.9299617,26.4561404",
  id: "briefcase-Stroke-265"
}), /*#__PURE__*/React.createElement("polyline", {
  id: "briefcase-Stroke-267",
  points: "50.7918445 22.8070175 50.7918445 41.0526316 1.52868658 41.0526316 1.52868658 22.8070175"
}), /*#__PURE__*/React.createElement("path", {
  d: "M17.9497392,5.47368421 L17.9497392,5.47368421 C17.9497392,2.45101435 20.375245,0 23.366457,0 L29.8663548,0 C32.8575667,0 35.2830725,2.45101435 35.2830725,5.47368421",
  id: "briefcase-Stroke-269"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "briefcase-Stroke-271",
  points: "10.6514936 27.963789 16.1251778 27.963789 16.1251778 24.036211 10.6514936 24.036211"
}), /*#__PURE__*/React.createElement("polygon", {
  id: "briefcase-Stroke-273",
  points: "36.1953532 27.963789 41.6690375 27.963789 41.6690375 24.036211 36.1953532 24.036211"
}), /*#__PURE__*/React.createElement("line", {
  x1: 16.1251778,
  y1: 26,
  x2: 36.1953532,
  y2: 26,
  id: "briefcase-Stroke-275"
})));

var SvgBriefcase = function SvgBriefcase(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "30px",
    height: "30px",
    viewBox: "0 0 54 54",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBriefcase, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/briefcase.bd0c46ba.svg";
export { ForwardRef as ReactComponent };